module.exports = __webpack_public_path__ + "img/pic_three.88b40142.png";